export const progressPercentageByOrderStatus: any = Object.freeze({
  NONE: 0,
  DRAFT: 0,
  WAITING: 15,
  PROCESSING: 30,
  PENDING_APPROVAL: 45,
  PENDING_PREPAYMENT: 60,
  READY: 85,
  PARTIALLY_SHIPPED: 95,
  SHIPPED: 100,
  CANCELLED: 100,
});
